import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EventLocation = ({ location }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 lg:p-8 space-y-6">
      <h2 className="text-2xl font-bold text-[var(--color-foreground)]">Location & Directions</h2>
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <Icon name="MapPin" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
          <div>
            <p className="font-semibold text-[var(--color-foreground)]">{location?.venue}</p>
            <p className="text-[var(--color-muted-foreground)] text-sm">{location?.address}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Icon name="Navigation" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
          <div>
            <p className="font-semibold text-[var(--color-foreground)] mb-1">Getting There</p>
            <p className="text-[var(--color-muted-foreground)] text-sm">{location?.directions}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Icon name="Car" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
          <div>
            <p className="font-semibold text-[var(--color-foreground)] mb-1">Parking</p>
            <p className="text-[var(--color-muted-foreground)] text-sm">{location?.parking}</p>
          </div>
        </div>
      </div>
      <div className="rounded-xl overflow-hidden h-64 bg-[var(--color-muted)]">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title={location?.venue}
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${location?.coordinates?.lat},${location?.coordinates?.lng}&z=14&output=embed`}
          className="border-0"
        />
      </div>
      <div className="flex gap-3">
        <Button 
          variant="outline" 
          fullWidth
          iconName="Navigation"
          iconPosition="left"
        >
          Get Directions
        </Button>
        <Button 
          variant="ghost" 
          fullWidth
          iconName="Share2"
          iconPosition="left"
        >
          Share Location
        </Button>
      </div>
    </div>
  );
};

export default EventLocation;